<template>
  <div>
      <div v-if="isVedioCall == true">
        <conference from="widget"></conference>
      </div>
      <div v-if="isVedioCall == false">
        <book-appointment></book-appointment>
      </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";
import Conference from "@/views/frontend/Conference"
import BookAppointment from "@/views/frontend/BookAppointment";
import $ from "jquery";

export default {
  props: {
    title: String,
    path: String
  },
  data() {
    return {
     isVedioCall: null,
    };
  },
  components:{
    'conference' : Conference,
    'book-appointment' : BookAppointment
   },
  mounted() {
    if($('#room-name').val() != undefined || this.$route.params.room) {
      this.isVedioCall = true;
      this.$store.dispatch("SetHeader");
    } else {
      this.isVedioCall = false;
    }
  },
};
</script>